import { Copy } from "lucide-react";
import type React from "react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";

import { copyToClipboard } from "~/common/functions";
import { Button } from "~/components/ui";

type Props = {
  text: string;
  children?: React.ReactNode;
};
export const TextWithCopy: React.FC<Props> = ({ children, text }) => {
  const { t } = useTranslation();

  return (
    <Button
      type="button"
      variant="ghost"
      size="sm"
      className="gap-1.5 px-1.5 font-normal"
      onClick={() => {
        copyToClipboard(text).catch(() => {
          toast.error(t("feature.common.copyToClipboardFailed"));
        });
      }}
    >
      {children ?? text}
      <Copy className="size-3.5" />
    </Button>
  );
};
